/**
 * 行政区划地图数据管理
 * 使用腾讯 COS 存储的 GeoJSON 数据
 */

const GEO_API_BASE =
  'https://litta-prd-1301594083.cos.ap-nanjing.myqcloud.com/litta-resources/litta-h5/js/geo';

const geoCache = {};

// 标准化区域名称（去除行政后缀）
export function normalizeName(name) {
  if (!name) return '';
  return name
    .replace(/壮族自治区$/, '')
    .replace(/回族自治区$/, '')
    .replace(/维吾尔自治区$/, '')
    .replace(/自治区$/, '')
    .replace(/特别行政区$/, '')
    .replace(/省$/, '')
    .replace(/市$/, '')
    .replace(/区$/, '')
    .replace(/县$/, '');
}

// 获取 GeoJSON 数据（带缓存）
export async function fetchGeoJSON(adcode, full = true) {
  const cacheKey = `${adcode}_${full ? 'full' : 'simple'}`;
  if (geoCache[cacheKey]) return geoCache[cacheKey];

  const url = `${GEO_API_BASE}/${adcode}${full ? '_full' : ''}.json`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`GeoJSON 加载失败: ${adcode}`);
  const data = await res.json();
  geoCache[cacheKey] = data;
  return data;
}

// 在 ECharts 中注册地图
export function registerMapData(name, geoData) {
  const echarts = window.echarts;
  if (!echarts) return;
  echarts.registerMap(name, geoData);
}

// 获取中国省级 GeoJSON
export async function loadChinaMap() {
  const geoData = await fetchGeoJSON(100000, true);
  return { geoData };
}

// 根据省份名称查找 adcode
export function findAdcodeByName(geoData, name) {
  if (!geoData?.features) return null;
  const feature = geoData.features.find((f) => {
    const fName = f.properties?.name || '';
    return fName === name || normalizeName(fName) === normalizeName(name);
  });
  return feature?.properties?.adcode || null;
}
